<div
  class="aprova-loading-spinner"
  [class.aprova-loading-spinner--overlay]="overlay"
>
  <div class="aprova-loading-spinner__content">
    <svg
      [style.width.px]="sizeInPx"
      [style.height.px]="sizeInPx"
      viewBox="0 0 100 100"
      class="spinner"
      [style.color]="color"
    >
      <defs>
        <linearGradient
          id="spinner-gradient"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="0%"
          gradientTransform="rotate(10)"
        >
          <stop offset="10%" stop-color="currentColor" />
          <stop offset="100%" stop-color="whitesmoke" />
        </linearGradient>
      </defs>

      <path
        d="M 50 10 A 40 40 0 1 0 90 50"
        stroke="url(#spinner-gradient)"
        [attr.stroke-width]="strokeWidth"
        fill="none"
        stroke-linecap="round"
      />
    </svg>

    <span *ngIf="text" class="aprova-loading-spinner__text">{{ text }}</span>
  </div>
</div>
